export default {
  sponsor_id: 'number',
  sort_order: 'number'
}



// WEBPACK FOOTER //
// ./src/store/models/sponsor.js